<template>
    <div class="right-container">
        <p class="right-h2">整体框架</p>
        <p class="right-h3">语义化标签</p>
        <p class="right-content">大多数的网站其实就像下图所示分为三个部分：头部，底部和中间的主体内容部分，然后主体内容里面还有一块一块的模块内容。</p>
        <img src="../../assets/img/img5.png">
        <p class="right-content">一般来说我们要做上图的这个结构可能会这样布局：</p>
        <div class="right-code">
            <pre>
                <code class="language-markup line-numbers" v-html="code.framework.framework1"></code>
            </pre>
        </div>
        <p class="right-content">但是全部都用div来布局的话就显得代码结构不够清晰，所以我们就可以用HTML5的语义化标签来重构代码结构：</p>
        <div class="right-code">
            <pre>
                <code class="language-markup line-numbers" v-html="code.framework.framework2"></code>
            </pre>
        </div>
        <p class="right-content">这样代码结构就清晰、简洁多了，而且后期维护与修改也能快速找到需要修改的地方。</p>
        <p class="right-h3">container</p>
        <p class="right-content">一般来说一个网站都会有一个container，它的作用是用来限制中间主体内容部分的宽度和保持居中，代码如下：</p>
        <div class="right-code">
            <pre>
                <code class="language-css line-numbers" v-html="code.framework.framework3"></code>
            </pre>
        </div>
        <p class="right-content">container再加上上面说的语义化标签，一个网站的整体结构就会变成这样：</p>
        <div class="right-code">
            <pre>
                <code class="language-markup line-numbers" v-html="code.framework.framework4"></code>
            </pre>
        </div>
        <p class="right-content">可能会有人好奇为什么不把container类名加在语义化标签上？这是因为一个模块可能会有背景图或者背景色，而container占不满一行不能在这上面设置背景图或者背景色，所以就需要放在下一层级。</p>
        <p class="right-content">以上就是一个网站的整体框架了，可以直接复制在代码里面然后直接在里面填充内容就行了，如果项目有特殊情况可以自行修改，但是大致的思路就是这样了。</p>
    </div>
</template>

<script>
import code from '../../utils/code'
import Prism from 'prismjs'
import 'prismjs/themes/prism.css'
export default {
    name: 'framework',
    data () {
        return {
            code: code
        }
    },
    mounted () {
        Prism.highlightAll()
    }
}
</script>

<style lang="scss" scoped>

</style>